/** @flow */

import {
  GetSpecialContactTypes,
  GetSpecialContactTypesSuccess,
  GetSpecialContactTypesError,
  SetCurrentSpecialContactType,
  SetShowSpecialContactTypeModal,
  SetShowDeleteSpecialContactTypeModal,
} from "@modules/service/constants/actions";
import * as specialContactsReducers from "./reducers";
import initialState from "./state";
import type { SpecialContactsTypesState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: SpecialContactsTypesState = initialState,
  action: Object,
): SpecialContactsTypesState => {
  const act = {
    [GetSpecialContactTypes]: specialContactsReducers.onGetSpecialContactTypes,
    [GetSpecialContactTypesSuccess]: specialContactsReducers.onGetSpecialContactTypesSuccess,
    [GetSpecialContactTypesError]: specialContactsReducers.onGetSpecialContactTypesError,
    [SetCurrentSpecialContactType]: specialContactsReducers.onSetCurrentSpecialContactType,
    [SetShowSpecialContactTypeModal]: specialContactsReducers.onSetShowSpecialContactTypeModal,
    [SetShowDeleteSpecialContactTypeModal]:
      specialContactsReducers.onSetShowDeleteSpecialContactTypeModal,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
